const handleFiltering = () => {
  // console.log('yo');

  const body = document.getElementsByTagName('body')[0];
  const drawer = document.getElementById('Facet-Drawer');

  let hash = window.location.hash;

  if ( hash === '#SideFilters') {
    if ( !drawer.classList.contains('active') ) {
      drawer.classList.add('active');
    }

    if ( !body.classList.contains('open-cc') ) {
      body.classList.add('open-cc');
    }
  }
}

// run on load
handleFiltering();